import "../components/Common/NoRights";

const Error = () => {
    return (
        <div className="report-content midcontent">
            <div className="noRight">
                <div className="text-center noRightContent">
                    <div className="icon">
                        <i className="fa fa-warning"></i>
                    </div>
                    <div className="noRightText" style={{ fontSize: "20px" }}>
                        Something went wrong! Please refresh your browser and try again!
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error;